module.exports = __webpack_public_path__ + "img/ICFC.a3f75a6c.png";